const AuthAppDirectCallbackView = () => import('@/views/auth/auth-appdirect-callback-view');
import { api } from '@/scripts/api';

export default [
    {
        path: '/Auth/AppDirect/Login',
        name: 'AuthAppDirectLogin',
        beforeEnter(to, from, next) {
            if (localStorage.jwt) {
                next('/');
                return;
            }

            var issuer = to.query.iss;
            var accountId = to.query.accountId;

            api.get(`/api/Accounts/${accountId}/AppDirect/ClientId`)
                .then(response => {
                    var params = [
                        'response_type=code',
                        'scope=openid profile email',
                        `client_id=${response.data.ClientId}`,
                        'redirect_uri=https://app.glasshive.com/Auth/AppDirect/Callback',
                        `state=${accountId}--${issuer}`
                    ].join('&');
                    
                    window.location.replace(`${issuer}/oauth2/authorize?${params}`);        
                })
                .catch(() => {
                    alert('An error occurred during the sign in process. Please try again.');
                });
        }
    },
    {
        path: '/Auth/AppDirect/Callback',
        name: 'AuthAppDirectCallback',
        component: AuthAppDirectCallbackView,
        meta: {
            type: 'general',
            isUiShown: false,
            pageClass: 'auth-appdirect-callback-page',
            pageTitle: 'AppDirect Authentication',
        },
    },
];
